<template>
  <div>
    <div style="margin-top: 30px; display: flex">
      <span style="font-size: 20px"> 维度：</span
      ><do-select-old
        style="width: 180px"
        :list="dimensionalitygroup"
        :ismoren="true"
        @setSelectValue="setSelectValue"
        obj="dimensionality"
        @change="reflash"
      ></do-select-old>
    </div>
    <div
      style="width: 100%; overflow: auto"
      v-if="this.dimensionality.length > 0"
    >
      <dobar-chart
        :cansortlegend="true"
        @onlengendchangey="onlengendchangey"
        :xAxisList="customX"
        :legend="dimensionality"
        :seriesList="series"
        :yAxisprop="yAxis"
        chartTitle="自定义图"
        style="margin: 20px auto 0px"
        ref="dobarchart1"
        :rotateprop="
          this.deleteRoI !== null ||
          (this.deleteRoI == null && customX.length > 16)
            ? 40
            : 0
        "
      ></dobar-chart>
    </div>
    <div
      v-else
      style="
        display: flex;
        justify-content: center;
        font-size: 40px;
        margin-top: 20%;
      "
    >
      请选择维度
    </div>
  </div>
</template>
<script>
import DobarChart from "@/components/DoBarChart";
import { filterarray } from "../../utils/tool";
import DoSelectOld from "@/components/DoSelectOld";
export default {
  components: {
    DoSelectOld,
    DobarChart,
  },
  props: {
    column: { type: Array, default: () => [] },
    customX: { type: Array, default: () => [] },
    // customlist: { type: Array, default: () => [] },
    listsortbycountry: { type: Array, default: () => [] },
    listsortbyincome: { type: Array, default: () => [] },
    list: { type: Array, default: () => [] },
    deleteRoI: { type: String },
  },
  computed: {
    dimensionalitygroup() {
      let arr = this.column.slice();
      arr.shift();
      let arr1 = arr.map((i) => i.name);
      return arr1;
    },
    columnfilter() {
      let arr = [];
      this.column.forEach((i) => {
        this.dimensionality.forEach((item) => {
          if (i.name == item) {
            arr.push(i);
          }
        });
      });
      // arr = this.column.filter((i) => {
      //   return i.name == "总新增";
      // });

      return arr;
    },
    customlist() {
      let arr = [];
      let arr1 = [];
      switch (this.deleteRoI) {
        case "2":
          arr = this.listsortbycountry;
          break;
        case "3":
          arr = this.listsortbyincome;
          break;
        case "4":
          arr = this.listsortbyincome;
          break;
        default:
          arr = this.list;
      }
      arr1 = JSON.parse(JSON.stringify(arr)).map((item) => {
        if (item["estimateValue"]) {
          item["estimateValue"] = item["estimateValue"].toFixed(2);
        }

        if (item["estimateTimes"]) {
          item["estimateTimes"] = item["estimateTimes"].toFixed(2);
        }
        return item;
      });
      // console.log(this.listsortbycountry);
      return arr1;
    },
    series() {
      let arr = [];
      let barnum = 0;
      let linenum = 0;
      this.columnfilter.forEach((item) => {
        let barlineindex = item.percent ? linenum : barnum;
        var colorList = item.percent
          ? ["#00B050", "#7030A0", "#C0504D", "#31859C", "#87A0BE", "#FFD966"]
          : ["#87A0BE", "#FFD966", "#31859C", "#C0504D", "#7030A0", "#00B050"];
        arr.push({
          name: Object.values(item.name).join(""),
          type: item.percent ? "line" : "bar",
          smooth: false,
          symbol: "circle",
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            normal: {
              width: 2,
            },
          },
          itemStyle: {
            // opacity: 0.5,
            color: colorList[barlineindex],
          },
          data: filterarray(this.customlist, item.key),
          // yAxisIndex: index,
          yAxisIndex: item.percent ? 1 : 0,
          // barWidth: "10%", //柱图宽度
        });
        if (item.percent) {
          linenum++;
        } else {
          barnum++;
        }
      });
      return arr;
    },
    yAxis() {
      let arr = [];
      // let leftarrsize = 0;
      // let rightarrsize = 0;

      // this.columnfilter.forEach((item) => {
      //   let colorarr = item.percent
      //     ? ["#00B050", "#7030A0", "#C0504D", "#31859C", "#87A0BE", "#FFD966"]
      //     : ["#87A0BE", "#FFD966", "#31859C", "#C0504D", "#7030A0", "#00B050"];

      //   if (item.percent) {
      //     arr.push({
      //       type: "value",
      //       name: item.name,
      //       position: "right",

      //       offset: 68 * rightarrsize,
      //       axisLabel: {
      //         formatter: "{value}%",
      //       },
      //       splitArea: { show: false }, //保留网格区域
      //       axisLine: {
      //         lineStyle: { color: colorarr[rightarrsize] },
      //       },
      //       nameTextStyle: { align: "right", fontSize: 10 },
      //     });
      //     rightarrsize++;
      //   } else if (item.unit) {
      //     arr.push({
      //       type: "value",
      //       name: item.name,

      //       position: "left",
      //       offset: 68 * leftarrsize,
      //       axisLabel: {
      //         formatter: "${value}",
      //       },
      //       splitArea: { show: false }, //保留网格区域
      //       axisLine: {
      //         lineStyle: { color: colorarr[leftarrsize] },
      //       },
      //       nameTextStyle: { align: "right", fontSize: 10 },
      //     });
      //     leftarrsize++;
      //   } else {
      //     arr.push({
      //       type: "value",
      //       name: item.name,
      //       position: "left",

      //       offset: 68 * leftarrsize,
      //       axisLabel: {
      //         formatter: "{value}",
      //       },
      //       splitArea: { show: false }, //保留网格区域
      //       axisLine: {
      //         lineStyle: { color: colorarr[leftarrsize] },
      //       },
      //       nameTextStyle: { align: "right", fontSize: 10 },
      //     });
      //     leftarrsize++;
      //   }
      // });
      arr = [
        {
          type: "value",

          position: "left",
          axisLabel: {
            formatter: "{value}",
          },
          splitArea: { show: false }, //保留网格区域
          axisLine: {},
          nameTextStyle: { align: "right", fontSize: 10 },
        },
        {
          type: "value",

          position: "right",
          axisLabel: {
            formatter: "{value}%",
          },
          splitArea: { show: false }, //保留网格区域
          axisLine: {},
          nameTextStyle: { align: "right", fontSize: 10 },
        },
      ];
      return arr;
    },
  },
  data() {
    return {
      dimensionality: [],
      chnlgroup: [
        { label: "区分渠道", value: "0" },
        { label: "汇总渠道", value: "1" },
      ],
    };
  },
  methods: {
    onlengendchangey(val, val1, val2) {
      console.log(val, val1, val2);

      // this.yAxis = val;
    },
    reflash() {
      this.$refs.dobarchart1 && this.$refs.dobarchart1.reflashChart();
    },
    setSelectValue(n) {
      let obj = n.obj;
      this[obj] = n.val;
    },
  },
  watch: {
    // deleteRoI: {
    //   handler(n) {
    //     this.$nextTick(() => {
    //       switch (n) {
    //         case "country":
    //           this.customlist = this.listsortbycountry;
    //           break;
    //         case "mediaSource":
    //           this.customlist = this.listsortbyincome;
    //           break;
    //         default:
    //           this.customlist = this.list;
    //       }
    //     });
    //   },
    //   immediate: true,
    // },
  },
};
</script>